import React, { useState, useEffect,useRef } from 'react';
import styles from './ModeratorBoxPublicView.module.css';
import avatar from './../../../assets/default-avatar.svg';
import { storage, firestore, auth }  from "../../../firebase/firebase.js";
import { formatDate, formatRelativeTime } from './../../../utils/dateHelpers/dateHelpers';
import { HiArrowRight } from "react-icons/hi2";
import { collection, query, orderBy, onSnapshot, addDoc, serverTimestamp } from 'firebase/firestore';
import { useAuth } from "../../../utils/AuthContext/authcontext";
import RulesTab from './../Rules/RulesTab';
import Button from '../../ui/Button';

export default function ModeratorBoxPublicView({capabilities, role, isSingleTeam, currentUserteam, isModerator, currentUserData, currentUser, arenaId, arena, moderator }) {
   const [activeTab, setActiveTab] = useState('Messages');
   const [mods, setMods] = useState([]);
    const [text, setText] = useState('');
	const [target, setTarget] = useState('all');
	const [modus, setModus] = useState([]);
	const [getModerator, setModerator] = useState(moderator);
	const [modusfiltered, setModusfiltered] = useState([]);
    const { searchbyUsersId } = useAuth();
	
  useEffect(() => {
    if (modus.length <= 0) return;
     const msg = modus.filter(n => n.username === currentUserData.username || n.target === 'all' || n.target.includes(currentUserteam));
     setModusfiltered(msg);
	 //console.log(modus);
	  
  }, [modus]);

    const enrichMessagesWithUser = async (mod) =>  {
	const cache = {};
		if (!cache[mod.uid]) {
			cache[mod.uid] = await searchbyUsersId(mod.uid);
			mod.profilePicture = cache[mod.uid]?.[0]?.profilePicture;
			mod.username = cache[mod.uid]?.[0]?.username;
		}
		return mod
	}

	useEffect(() => {
	const process = async () => {
		if (!moderator) return;
		const enriched = await enrichMessagesWithUser(moderator);
		setModerator(enriched);
	};

	process();
	}, [moderator]);

	
	useEffect(() => {
	  const startRound = async () => {
		if(mods.length > 0) {
			let debt = await Promise.all(mods.map(async (msg) => {
				if(msg?.target != undefined && msg?.target != "all" && msg?.target.includes("team:") == false) {
					const users = await searchbyUsersId(msg?.target);
					if(users != undefined && users.length > 0) {
						msg.username = users[0].username;
					}
				}
				else
				{
					msg.username = msg?.target;
				}
				return msg;
			}))

			setModus(debt);
		}
	  };
	  startRound();
	}, [mods]);
  
	useEffect(() => {
	const q = query(
	  collection(firestore, 'arenas', arenaId, 'moderatormessages'), orderBy('createdAt', 'desc')
	);
	const unsubscribe = onSnapshot(q, snapshot => {
	  setMods(snapshot.docs.map(d => ({ id: d.id, ...d.data() })));
	});
	return () => unsubscribe();
	}, [arenaId]);
	
	// Capitalize first letter utility
	function capitalizeFirst(str) {
		if (!str) return '';
		return str.charAt(0).toUpperCase() + str.slice(1);
	}

	return (
    <div className={`${isSingleTeam == true ? styles.boxsingle : styles.box}`} > 
		<div className={`${isSingleTeam == true ? styles.moderatorBoxSingle : styles.moderatorBox}`}>
		  <div className={currentUser.uid === getModerator?.uid ? `${styles.header} ${styles.you}` : styles.header}>
			<img src={getModerator?.profilePicture || avatar} alt="Moderator" />
			<div>
			  <div className={styles.name}>{getModerator?.username}</div>
			  <div className={styles.role}>{capitalizeFirst(role)}</div>
			</div>
		  </div>
		  {getModerator?.uid == undefined ? <> <div>invitation sent to {getModerator?.email} is still pending.</div></> :
		  <><div className={styles.tabs}>
			{['Messages', 'Rules'].map(tab => (
			  <Button
				key={tab}
				variant={activeTab === tab ? 'primary' : 'ghost'}
				className={activeTab === tab ? styles.activeTab : ''}
				onClick={() => setActiveTab(tab)}>
				{capitalizeFirst(tab)}
			  </Button>
			))}
		  </div>

		  <div className={styles.content}>
			{activeTab === 'Messages' && (
			  <>
				{/*<div className={styles.timeline}><TurnTimeline formatId={arena.formatId} currentTurnId={'CG'} /></div>*/}
				  <div className={styles.messagePanel}>
				    {modusfiltered.length > 0 ? <><h3 className={styles.title}>{capitalizeFirst('Messages')}</h3>
					{modusfiltered.map(m => (
					  <div key={m.id} className={styles.modMessage}>
						<div className={styles.modMeta}>
						  <div className={styles.modname}>{m.target?.includes(currentUserteam) ? <span>{currentUserteam}</span> : <>{m.target !== 'all' && m.target !== undefined ? <span>Me</span> : <><span>All</span></> }</>}</div>
						  <span className={styles.modTime} title={formatDate(m.createdAt)}>
							{formatRelativeTime(m.createdAt)}
						  </span>
						</div>
						<div className={styles.modContent}>{m.content}</div>
					  </div>
					))}</>  : <div className={styles.noMessages}>No messages yet.</div>}
				  </div>
			  </>
			)}

			{activeTab === 'Rules' && (
			  <div className={styles.rulesSection}>
				{/* Possibly render formatId explanation, time rules, etc. 
				<ul>
				  <li>Debate Format: {arena.formatId}</li>
				  <li>Time per round: {arena.custom.time}s</li>
				  <li>Total Rounds: {arena.custom.rounds}</li>
				</ul>*/}
				<RulesTab formatId={arena.formatId} isModerator={isModerator} arenaId={arenaId} />
			  </div>
			)}
			</div></>}
		</div>
	</div>
  );
}
